/**
 * Browser polyfill for the Node.js `Buffer` global — required by `hl7v2-dictionary` at module
 * load time. Import this file before any `hl7v2`-touching import.
 */

// biome-ignore lint/style/useNodejsImportProtocol: protocol-less `buffer` deliberately resolves to the npm polyfill package
import { Buffer as BufferPolyfill } from 'buffer';

const target = globalThis as { Buffer?: typeof BufferPolyfill };

if (typeof target.Buffer === 'undefined') {
  target.Buffer = BufferPolyfill;
}
